module.exports = __webpack_public_path__ + "img/plant-livingroom-pc.ab4d22e6.png";